module.exports = __webpack_public_path__ + "static/img/demo1.9dbd5f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/demo1.jpg
// module id = a+Nl
// module chunks = 1